if (!customElements.get("announcement-slider")) {
	class AnnouncementSlider extends HTMLElement {
		connectedCallback() {
			this.slides = Array.from(
				this.querySelectorAll(".announcement-bar__slide")
			);
			this.bar = this.closest(".announcement-bar");
			this.intervalId = null;
			this.intervalMs = Number(this.dataset.interval) || 4000;
			this.currentIndex = Math.max(
				this.slides.findIndex((slide) => slide.classList.contains("is-active")),
				0
			);
			this.autoplay =
				this.dataset.autoplay === "true" &&
				this.slides.length > 1 &&
				!window.matchMedia("(prefers-reduced-motion: reduce)").matches;

			if (this.slides.length === 0) return;

			this.updateSlides(this.currentIndex);

			if (!this.autoplay) return;

			this.handleMouseEnter = this.stopAutoplay.bind(this);
			this.handleMouseLeave = this.startAutoplay.bind(this);
			this.handleFocusIn = this.stopAutoplay.bind(this);
			this.handleFocusOut = (event) => {
				if (this.contains(event.relatedTarget)) return;
				this.startAutoplay();
			};

			this.addEventListener("mouseenter", this.handleMouseEnter);
			this.addEventListener("mouseleave", this.handleMouseLeave);
			this.addEventListener("focusin", this.handleFocusIn);
			this.addEventListener("focusout", this.handleFocusOut);
			this.startAutoplay();
		}

		disconnectedCallback() {
			this.stopAutoplay();

			if (!this.handleMouseEnter) return;

			this.removeEventListener("mouseenter", this.handleMouseEnter);
			this.removeEventListener("mouseleave", this.handleMouseLeave);
			this.removeEventListener("focusin", this.handleFocusIn);
			this.removeEventListener("focusout", this.handleFocusOut);
		}

		startAutoplay() {
			if (!this.autoplay || this.intervalId) return;

			this.intervalId = window.setInterval(() => {
				this.goToSlide(this.currentIndex + 1);
			}, this.intervalMs);
		}

		stopAutoplay() {
			if (!this.intervalId) return;

			window.clearInterval(this.intervalId);
			this.intervalId = null;
		}

		goToSlide(index) {
			if (this.slides.length < 2) return;

			const nextIndex = (index + this.slides.length) % this.slides.length;
			if (nextIndex === this.currentIndex) return;

			this.currentIndex = nextIndex;
			this.updateSlides(this.currentIndex);
		}

		updateSlides(activeIndex) {
			this.slides.forEach((slide, index) => {
				const isActive = index === activeIndex;
				slide.classList.toggle("is-active", isActive);
				slide.setAttribute("aria-hidden", String(!isActive));

				const slideLinks = slide.querySelectorAll("a");
				slideLinks.forEach((link) => {
					link.tabIndex = isActive ? 0 : -1;
				});
			});

			const activeSlide = this.slides[activeIndex];
			if (this.bar && activeSlide?.dataset.backgroundColor) {
				this.bar.style.setProperty(
					"--announcement-background",
					activeSlide.dataset.backgroundColor
				);
			}
		}
	}

	customElements.define("announcement-slider", AnnouncementSlider);
}
